import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import useGetEmployer from '@/modules/employer/hooks/useGetEmployer.query';

export const QUERY_KEY = 'GET_EMAIL_THEMES';


export interface Theme {
  id: string;
  name: string;
  subject: string;
  text: string;
  activeLink: string;
  buttonBackground: string;
  buttonText: string;
  codeText: string;
  codeBackground: string;
}

export default (orgPath?: string) => {
  const { formattedData: formattedEmployer } = useGetEmployer();
  const { data, isLoading, isSuccess } = useQuery(
    [QUERY_KEY],
    () =>
      api.get(API_URL.EMAIL_TEMPLATE_THEMES, {
        params: {
          organization_path: orgPath || formattedEmployer.organizationPath,
        },
      }),
    {
      enabled: !!(orgPath || formattedEmployer?.organizationPath),
    }
  );

  const formatted = useMemo(() => {
    const list = data?.data || [];
    return list.map((item) => ({
      key: `${item.id}`,
      title: item.name || '',
      color: item.button_background ? `${item.button_background}` : '',
    }));
  }, [data]);

  const formattedThemes = useMemo<Array<Theme>>(() => {
    const themes = data?.data || [];

    return themes.map((theme) => ({
      id: `${theme?.id}`,
      name: theme?.name || '',
      activeLink: theme?.active_link || '',
      buttonBackground: theme?.button_background || '',
      buttonText: theme?.button_text || '',
      codeBackground: theme?.code_background || '',
      codeText: theme?.code_text || '',
      subject: theme?.subject || '',
      text: theme?.text || '',
    }));
  }, [data]);

  return {
    formattedThemes,
    data: formatted,
    isLoading,
    isSuccess,
  };
};
